<template>
  <d-modal
    size="lg"
    class="big-popup"
    @close="closePopup">
    <d-modal-header>
      <d-modal-title
        class="d-flex">
        {{ $t('order.orderPreview') }}:&nbsp;<strong class="text-primary">&nbsp;#{{ orderID }}</strong>

        <d-button
          theme="primary"
          outline
          size="sm"
          @click.native="orderActionUrl(orderID)"
          class="ml-3"
          :title="$t('ui.edit')">
          <i class="material-icons">edit</i>
        </d-button>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="p-4">
      <d-alert
        :show="!loadError && !loadedOrderData"
        theme="light"
        class="py-5 text-center">
        {{ $t('order.offerLoading') }}&hellip;
      </d-alert>

      <d-alert
        :show="loadError"
        theme="warning"
        class="text-center">
        {{ $t('order.orderLoadingErrorTryAgain') }}&hellip;
      </d-alert>

      <div
        v-if="loadedOrderData && orderData && orderData.html"
        v-pure-html="orderData.html"
        class="order-data-html-wrapper">
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import OrderView from './OrderView';

export default {
  name: 'order-summary-popup',
  props: [
    'orderID',
    'orderUrl'
  ],
  components: {
    'order-view': OrderView
  },
  computed: {
    isOffersView () {
      return this.$route.path === '/oferty';
    },
    isInquiriesView () {
      return this.$route.path === '/zapytania';
    },
    isIndentList () {
      return this.$route.path.indexOf('/zamowienia-indent') > -1 || this.$route.path.indexOf('/oferty-indent') > -1;
    }
  },
  data () {
    return {
      orderData: {
        html: ''
      },
      loadedOrderData: false,
      loadError: false
    }
  },
  mounted () {
    this.loadedOrderData = false;
    this.loadError = false;
    this.loadOrderData();
  },
  methods: {
    loadOrderData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/orders/preview/' + parseInt(this.orderID, 10),
        method: 'get',
        loadedKey: 'loadedOrderData',
        outputKey: 'orderData',
        errorKey: 'loadError',
        noPagination: true
      });
    },
    closePopup () {
      this.$bus.$emit('order-summary-popup-close');
    },
    orderActionUrl (orderID) {
      if (this.isInquiriesView) {
        return this.$router.push('/zapytania/zapytanie/' + orderID);
      }

      if (this.isOffersView) {
        if (this.isIndentList) {
          return this.$router.push('/oferty-indent/edycja/' + orderID);
        }

        return this.$router.push('/oferty/edycja/' + orderID);
      }

      if (this.isIndentList) {
        return this.$router.push('/zamowienia-indent/edycja/' + orderID);
      }

      return this.$router.push('/zamowienia/edycja/' + orderID);
    }
  }
}
</script>

<style lang="scss" scoped>
.order-data-html-wrapper {
  margin: 0 auto;
  max-width: 960px;
  width: 100%;
}

.order-data-html-wrapper /deep/ {
  p {
    margin-bottom: 10px;
  }

  ol {
    padding-left: 20px;

    li::marker {
      color: #999;
    }
  }

  table {
    width: 100%;

    strong {
      font-weight: bold;
    }

    td td {
      padding: 0;
    }

    &.table-border {
      border: 1px solid #ccc;
      margin-top: 20px;

      td {
        border: 1px solid #ccc;

        td {
          padding: 0;
        }

        strong {
          font-weight: bold;
        }
      }
    }

    &.summary-table td {
      text-align: right!important;
    }

    th {
      background: #eee;
      padding: 5px 10px;
    }

    td {
      padding: 5px 10px;
    }

    td[style="border-bottom: 1px solid black"] {
      border-bottom-color: #ccc!important;
    }
  }
}
</style>
